import React, {Component} from 'react';
import getFieldFactory from "../../Endpoint/FieldFactory";
import FieldGroups from "../FieldGroups";
import {connect} from "react-redux";
import {addSubField} from "../../../../../store/actions/subFields";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import ParametersNotice from "../../Parameters/ParametersNotice";

class DefaultFieldsFilter extends Component {

	state = {
		selectedFilterToAdd: ''
	};

	handleSelectedFilterToAdd = (e) => {
		this.setState({selectedFilterToAdd: e.target.value});
	};

	render() {

		const { addSubField, group } = this.props;

		const defaultFields = [
			{
				name: 'taxonomy',
				label: 'Taxonomy',
				fields: [
					getFieldFactory().getSourceField(),
					{
						id: 'value',
						inputType: 'checkboxes',
						source: 'taxonomies',
						sourceName: 'name',
						sourceValue: 'value',
						value: '',
						label: 'Taxonomy',
						defaultValue: 'Select a taxonomy',
					},
					getFieldFactory().getParametersField(),
				],
			},
			getFieldFactory().getNewDefaultFieldGroup( 'object_ids', 'Post IDs', 'input', 'Value (separated by comma)' ),
			getFieldFactory().getYesNoFieldGroup( 'hide_empty', 'Hide empty' ),
			getFieldFactory().getNewDefaultFieldGroup( 'include', 'Include term IDs', 'input', 'Value (separated by comma)' ),
			getFieldFactory().getNewDefaultFieldGroup( 'exclude', 'Exclude term IDs', 'input', 'Value (separated by comma)' ),
			getFieldFactory().getNewDefaultFieldGroup( 'name', 'Term names', 'input', 'Value (separated by comma)' ),
			getFieldFactory().getNewDefaultFieldGroup( 'slug', 'Term slugs', 'input', 'Value (separated by comma)' ),
			getFieldFactory().getNewDefaultFieldGroup( 'term_taxonomy_id', 'Term taxonomy IDs', 'input', 'Value (separated by comma)' ),
			getFieldFactory().getYesNoFieldGroup( 'Hierarchical', 'Hierarchical' ),
			getFieldFactory().getNewDefaultFieldGroup( 'search', 'Search' ),
			getFieldFactory().getNewDefaultFieldGroup( 'name__like', 'Name like' ),
			getFieldFactory().getNewDefaultFieldGroup( 'description__like', 'Description like' ),
			getFieldFactory().getNewDefaultFieldGroup( 'child_of', 'Child of' ),
			getFieldFactory().getNewDefaultFieldGroup( 'parent', 'Parent' ),
			getFieldFactory().getYesNoFieldGroup( 'childless', 'Childless' ),
			getFieldFactory().getYesNoFieldGroup( 'cache_domain', 'Cache domain' ),
		];

		return (
				<FieldGroupContext.Consumer>

					{({ endpointId, endpoint, currentItem, action }) => (

						<React.Fragment>
							<h3>Default Fields ({endpoint[action][currentItem].defaultFields.length})</h3>

							<p>Use this section for adding a filter for one or more default taxonomy fields. You can set a fixed value for it or use an already defined parameter.</p>

							<ParametersNotice parameters={endpoint.parameters}/>

							<select value={this.state.selectedFilterToAdd} onChange={this.handleSelectedFilterToAdd}>
							<option value="">Select a field</option>
								{defaultFields.map((el, index) => <option key={index} value={el.name}>{el.label}</option>)}
							</select>

							<button
							onClick={() => addSubField(endpointId, defaultFields.filter(el => el.name === this.state.selectedFilterToAdd), currentItem, group, action)}
							disabled={!this.state.selectedFilterToAdd ? 'disabled' : ''}
							className="button-secondary"
							>
							Add a filter
							</button>

							<FieldGroups group={group} />

						</React.Fragment>
					)}

				</FieldGroupContext.Consumer>
		);
	}
}

const mapStateToProps = ( state ) => ( state );

const mapDispatchToProps = dispatch => ({
	addSubField: ( endpointId, field, currentItem, group, parentGroup ) => dispatch( addSubField( endpointId, field, currentItem, group, parentGroup ) ),
});

export default connect( mapStateToProps, mapDispatchToProps )(DefaultFieldsFilter);
